export enum AdminPitchListsRoutes {
  CreateLink = 'create-link',
  DeleteLinks = 'delete-links',
  GetLinks = 'get-links',
  RestoreLists = 'restore-lists',
  UpdateMany = 'update-many',
}
